'use client';

import 'swiper/css';
import 'swiper/css/effect-fade';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade } from 'swiper/modules';

import { IBlockImageGallery } from 'app/interfaces/blocks';
import { defaultProcessText } from 'app/utility/textProcessing';
import SwiperButtonPrev from 'app/components/common/SwiperButtonPrev';
import SwiperButtonNext from 'app/components/common/SwiperButtonNext';
import WithSwiper from 'app/components/common/WithSwiper';
import ImageBg from 'app/components/common/ImageBg';

export default function BlockImageGallery({
  block
}: {
  block: IBlockImageGallery;
}) {
  if (!block?.data?.images?.length) return null;
  const { images, description } = block.data;
  return (
    <Swiper modules={[EffectFade]} effect={'fade'} className="w-full">
      {images.map((item, index) => {
        return (
          <SwiperSlide key={index}>
            <div className="grid lg:grid-cols-2 lg:gap-4">
              <div className="relative pb-16/9 bg-brown rounded overflow-hidden group lg:col-start-2">
                <div className="rounded group-hover:scale-105 transition-transform duration-700">
                  <ImageBg
                    src={item.url}
                    alt={item.alt || ''}
                    fill
                    placeholderDataURL={item.placeholder_data_url}
                    className="object-cover rounded"
                  />
                </div>
              </div>
            </div>
          </SwiperSlide>
        );
      })}
      <div className="flex justify-between items-center gap-10 lg:grid lg:grid-cols-2 lg:gap-4 pt-5">
        {!!description && (
          <div className="lg:grid lg:grid-cols-2 lg:gap-4">
            <div
              className="text-h2 md:text-h1 lg:col-start-2"
              dangerouslySetInnerHTML={{
                __html: defaultProcessText(description)
              }}
            ></div>
          </div>
        )}

        <WithSwiper>
          {({ isLocked }) =>
            !isLocked && (
              <div className="flex gap-1 justify-end">
                <SwiperButtonPrev />
                <SwiperButtonNext />
              </div>
            )
          }
        </WithSwiper>
      </div>
    </Swiper>
  );
}
